// extracted by mini-css-extract-plugin
export default {"pageWrapper":"pageWrapper_pageWrapper__KbrXw"};